var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 115,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.062 43.656c.594 4.544 1.787 8.826 3.65 11.991-8.018 13.09-17.547 19.03-18.875 19.817l-.135.125-.026-.03a.078.078 0 00-.009.004l-.04-.063L40.72 51.867l-.845 6.708 12.512 54.433s-7.305 3.408-9.562-3a39248.362 39248.362 0 00-11.542-32.533l-5.45.156s-9.089 25.571-11.883 32.443c-2.869 7.058-9.803 2.647-9.803 2.647l13.408-54.984-1.445-12.54c-2.572-.254-7.043-.664-11.23-.872-6.4-.32-4.878-7.61-2.766-9.878l66.53-.416c.397-5.735 1.542-10.985 3-14.73-2.417-4.72-6.589-9.363-9.395-12.195L42.555 29.93l-4.48-.326L61.165.95l.047.044c.79.513 11.87 7.827 18.326 18.872-2.282 3-3.594 8.583-3.857 14.684.543 1.474 1.39 5.404-4.59 6.274-9.146 1.33-25.848 3.458-29.475 3.918l-.347 2.76L61 69.803c3.347-3.088 8.954-8.795 10.644-13.767-1.247-2.998-2.075-6.238-2.572-9.543l6.991-2.836zM18.96 20.937C17.55 9.697 35.761 7.46 35.761 20.086c0 12.789-15.445 11.665-16.802.851z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchery);
export default __webpack_public_path__ + "static/media/archery.d70d1f039898f3c63f56b1233a751e5d.svg";
export { ForwardRef as ReactComponent };